import * as angular from 'angular';

import { IRequestService } from '../index';
import { popoverItem } from '../../common';
import { GroupDependency, PopoverItemData } from '../../models';


export interface IGroupDependencyService {
    getPrecedents(guid: string): angular.IPromise<GroupDependency>;
    getDependents(guid: string): angular.IPromise<GroupDependency>;
}

export class GroupDependencyService implements IGroupDependencyService {
    static serviceId = 'groupDependencyService';
    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getPrecedents(guid: string): angular.IPromise<GroupDependency> {
        return this._requestService.getAtV1(`group/getPrecedencyTree/${guid}`)
            .then((data: GroupDependency) => {
                this.setAttributesForOne(data);
                this.setAttributes(data.contributorList);
                return data;
            });
    }

    getDependents(guid: string): angular.IPromise<GroupDependency> {
        return this._requestService.getAtV1(`group/getDependencyTree/${guid}`)
            .then((data: GroupDependency) => {
                this.setAttributesForOne(data);
                this.setAttributes(data.dependentList);
                return data;
            });
    }

    private setAttributes(items: GroupDependency[]) {
        items.forEach(data => {
            this.setAttributesForOne(data);
            if (data.contributorList && data.contributorList.length > 0) {
                this.setAttributes(data.contributorList);
            }
            if (data.dependentList && data.dependentList.length > 0) {
                this.setAttributes(data.dependentList);
            }
        });
    }

    private setAttributesForOne(data: GroupDependency) {
        const itemData: PopoverItemData = {
            guid: data.guid,
            name: data.name,
            type: data.type,
            groupUniqueName: data.uniqueName,
            comment: data.comment,
            shortComment: data.shortComment,
            longComment: data.longComment,
            parentUniqueName: data.parentUniqueName
        };
        data.attributes = {
            compile: 'wt-popover-svg',
            'wt-popover-svg': 'true',
            'item': popoverItem(itemData),
            template: 'groupPopoverTemplate.html'
        };
    }
}